import type { DirectDealsConfig } from '@openx/components-direct-deals/lib/utils/context/types';
import { useDirectDealsContact } from './utils/useDirectDealsContact';
import { useDirectDealsDetailsFetch } from './utils/useDirectDealsDetailsFetch';
import { useDirectDealsList } from './utils/useDirectDealsList';
import { useDirectDealsListFetch } from './utils/useDirectDealsListFetch';

export const directDealsConfig: DirectDealsConfig = {
  useDirectDealsListFetch,
  useDirectDealsList,
  useDirectDealsDetailsFetch,
  useDirectDealsContact,
};
